import React, { useState } from "react";
import { Card, Input, Tabs } from "antd";
import CasesTable from "./components/CasesTable";
import "./index.css";

const CasesList: React.FC = React.memo(() => {
  const [activeTab, setActiveTab] = useState("paid");

  const items = [
    {
      key: "paid",
      label: (
        <div
          style={{
            background: activeTab === "paid" ? "#1F5782" : "#f8f8f8",
            color: activeTab === "paid" ? "#fff" : "#999",
            borderRadius: "12px 12px 0 0",
            padding: "8px 46px",
          }}
        >
          Cases List 1
        </div>
      ),
      children: <CasesTable />,
    },
    {
      key: "unpaid",
      label: (
        <div
          style={{
            background: activeTab === "unpaid" ? "#1F5782" : "#f8f8f8",
            color: activeTab === "unpaid" ? "#fff" : "#999",
            borderRadius: "12px 12px 0 0",
            padding: "8px 46px",
          }}
        >
          Cases List 2
        </div>
      ),
      children: <CasesTable />,
    },
  ];

  return (
    <Card
      style={{
        border: "none",
        borderRadius: 8,
      }}
      className="cases-list-card"
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{
          borderBottom: "2px solid #1F5782",
        }}
        className="custom-tabs"
        tabBarExtraContent={
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <Input
              placeholder="Search"
              style={{
                width: 200,
                borderRadius: 4,
                border: "1px solid #ccc",
              }}
            />
            <span
              style={{
                color: "#1F5782",
                fontWeight: 500,
                cursor: "pointer",
                background: "#f8f8f8",
                padding: "4px 16px",
                borderRadius: 8,
              }}
            >
              See All →
            </span>
          </div>
        }
      />
    </Card>
  );
});

export default CasesList;
